<h2 mat-dialog-title>{{ isEditMode ? 'Edit Notification' : 'New Notification' }}</h2>

<mat-dialog-content [formGroup]="form">

  <div class="two-col">
    <mat-form-field appearance="outline">
      <mat-label>Title</mat-label>
      <input matInput formControlName="title" placeholder="Enter notification title" />
      <mat-error *ngIf="form.get('title')?.hasError('required')">Title is required</mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Type</mat-label>
      <mat-select formControlName="type">
        <mat-option *ngFor="let opt of typeOptions" [value]="opt.value">{{ opt.label }}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="form-group">
    <label class="field-label">Content <span class="required">*</span></label>
    <quill-editor
      formControlName="content"
      [modules]="quillModules"
      (onContentChanged)="onContentChanged($event)"
      placeholder="Write your notification content here…">
    </quill-editor>
    <div class="char-count" [class.over-limit]="charCount > maxChars">
      {{ charCount }} / {{ maxChars }}
    </div>
    <mat-error *ngIf="form.get('content')?.touched && form.get('content')?.hasError('required')">
      Content is required
    </mat-error>
  </div>

  <!-- Send notification checkbox — edit mode only -->
  <div class="send-box" *ngIf="isEditMode">
    <mat-checkbox formControlName="sendNotification">Re-notify users</mat-checkbox>
    <p class="send-hint">
      Check to push this notification to all users again.
      Leave unchecked to save silently, e.g. for a typo fix.
    </p>
  </div>

</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button (click)="onCancel()">Cancel</button>
  <button mat-raised-button color="primary" (click)="onSave()" [disabled]="form.invalid || charCount > maxChars">
    <mat-icon>{{ isEditMode ? 'save' : 'send' }}</mat-icon>
    {{ isEditMode ? 'Save Changes' : 'Create & Publish' }}
  </button>
</mat-dialog-actions>
